import tw, { css, styled } from 'twin.macro'
import { Link } from 'gatsby'
import { Circle, PlayCircle } from 'react-feather'
import Tooltip from '@reach/tooltip'
import { AccordionButton, AccordionPanel } from '@reach/accordion'
import { animated } from 'react-spring'

export const ProductInfoContainer = tw.section`w-full m-auto flex py-16 flex-col lg:flex-row`
export const ProductContainer = tw.div`w-full lg:w-7/12 xl:w-6/12 flex flex-col-reverse md:flex-row justify-center mb-10 lg:mb-0 relative md:static`
export const ProductImageContainer = styled.div`
	${tw`lg:w-9/12 xl:w-8/12 mx-4 md:mr-0 md:ml-4 bg-white flex items-center justify-center`}
	height: 600px;
	max-height: 600px;

	@media (max-width: 767px) {
		height: 300px;
		max-height: 300px;
	}

	> div.magnifier {
		${tw`w-auto!`}
	}

	> div.magnifier > img.magnifier-image {
		@media (max-width: 767px) {
			max-height: 300px;
			${tw`w-auto!`}
		}
	}
`
export const ProductImage = styled.img`
	src: url(${props => props.src});
	max-width: 550px;

	@media (min-width: 1024px) and (max-width: 1699px) {
		max-width: 400px;
	}
	@media (max-width: 767px) {
		max-width: 300px;
		max-height: 250px;
	}
`
export const ProductImageHolder = tw.div`flex flex-col mt-2 md:mt-0 items-center lg:w-3/12 xl:w-4/12 items-end`
export const ProductImagesContainer = tw.div`flex flex-col justify-center items-center overflow-hidden px-4 md:px-0 w-full md:w-auto`
export const ProductImageList = styled.ul`
	${tw`flex flex-row md:flex-col w-auto relative flex-wrap md:flex-nowrap overflow-y-auto`}
	transition: all .3s linear;
	max-width: 360px;
	max-height: 600px;
	img {
		${tw`cursor-pointer bg-white m-auto`}
		height: 80px;
		width: auto;
	}
	li {
		min-height: 90px;
		&:last-of-type {
			${tw`mb-1 md:mb-0!`}
		}
		&:first-of-type {
			${tw`mt-1 md:mt-0!`}
		}

		${tw`w-4/12 md:w-auto flex-none flex items-center justify-center py-2 my-1! px-0 mr-0 md:mr-1 md:px-1 bg-white`}

		&.roundview {
			${tw`flex-none md:flex items-center justify-center`}
			> p {
				${tw`cursor-pointer font-display text-center font-bold hover:text-gray-600 flex items-center justify-center h-full py-8`}
			}
		}
	}

	@media (max-width: 767px) {
		${tw`w-full`}
		max-width: 100%;

		img {
			${tw`w-8/12 h-auto`}
		}

		> li:nth-of-type(3n + 1) {
			${tw`border-white border-r-4 border-solid`}
		}
		> li:nth-of-type(3n + 3) {
			${tw`border-white border-l-4 border-solid`}
		}
		> li:nth-of-type(3n - 7) {
			${tw`border-white border-l-4 border-r-4 border-solid`}
		}
	}
	@media (max-width: 524px) {
		img {
			${tw`w-full`}
		}
	}
`
export const InfoContainer = styled.div`
	@media (min-width: 525px) {
		${tw`px-10`}
	}
	${tw`flex flex-col w-full lg:w-5/12 xxl:w-4/12 px-3`}

	hr {
		${tw`h-auto w-full border border-gray-400 my-4`}
	}
`
export const BreadCrumbsContainer = tw.div`flex flex-row mb-4`
export const Crumbs = styled(Link)`
	${tw`font-display mr-3 text-sm`}

	&:not(:first-of-type) {
		${tw`ml-3`}
	}
`
export const SeriesCrumbs = styled(Link)`
	${tw`font-display mx-3 text-sm`}
`
export const ProductTitle = tw.h1`font-display font-thin text-blue-500 text-4xl leading-none mb-2`
export const Price = tw.p`text-2xl`
export const SKU = tw.p`text-base text-sm mb-2`
export const CtaContainer = styled.div`
	${tw`flex mt-2 flex-row`}

	> input {
		${tw`text-center font-display w-2/12 p-2 mr-2`}
		background-color: #eaeaea;

		&[type='number']::-webkit-outer-spin-button,
		&[type='number']::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		&[type='number'] {
			-moz-appearance: textfield;
		}
	}
`
export const Button = styled.button`
	${tw`font-sans w-full ml-2 border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 hover:text-white text-dolphin-gray py-2 px-6 rounded cursor-pointer`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
	&.alt {
		${tw`border-yellow-500 hover:border-yellow-400 bg-transparent hover:bg-yellow-400 text-dolphin-gray hover:text-dolphin-gray`}
	}
`

export const Request = styled(Link)`
	${tw`font-sans w-full border-2 border-yellow-500 hover:border-yellow-700 bg-yellow-500 hover:bg-yellow-700 hover:text-white text-dolphin-gray py-2 px-6 rounded cursor-pointer text-center`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
	&.alt {
		${tw`border-yellow-700 hover:border-yellow-500 bg-transparent hover:bg-yellow-500 text-dolphin-gray hover:text-dolphin-gray`}
	}
`

export const BookQuote = styled(Link)`
	${tw`font-sans w-full ml-2 border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 text-dolphin-gray py-2 px-6 rounded cursor-pointer text-center`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
	&.alt {
		${tw`border-yellow-500 hover:border-yellow-400 bg-transparent hover:bg-yellow-400 text-dolphin-gray hover:text-dolphin-gray`}
	}
`
export const CompareBtn = styled.a`
	${tw`font-sans w-full ml-2 border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 hover:text-white text-dolphin-gray py-2 px-6 rounded cursor-pointer text-center`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
	&.alt {
		${tw`border-yellow-500 hover:border-yellow-400 bg-transparent hover:bg-yellow-400 text-dolphin-gray hover:text-dolphin-gray`}
	}
`
export const ControlsContainer = tw.div`flex flex-col`
export const IncrementBtn = tw.button``
export const DecrementBtn = styled.button`
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const FssContainer = tw.div`flex flex-col w-full mt-8 md:mt-16`
export const TabsContainer = tw.div`flex flex-row mb-8`
export const Tab = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-display text-xs uppercase border-b-2 border-gray-400 w-4/12 py-4`}
	&.active {
		${tw`border-l-2 border-r-2 border-t-2 border-b-0 px-2`}
	}
	&:focus:focus {
		${tw`shadow-none`}
	}
`
export const TabDetailsContainer = tw.div``
export const SpecificationsContainer = tw.div`w-full`
export const SpecificationsList = tw.ul`flex flex-col`
export const SpecificationsListItem = tw.li`mb-4`
export const SpecDetail = tw.p`font-display text-gray-700`
export const Spec = tw.span`font-bold`
export const SpecGroupTitle = tw.h3`font-display text-gray-700 font-bold text-xl underline underline decoration-slice mb-2`

export const SupportContainer = tw.div`w-full flex flex-row justify-start md:justify-center overflow-x-auto gap-2`
export const Manual = tw.a`font-display  bg-dolphin-gray text-white flex items-center text-sm lg:text-base border border-2 border-dolphin-gray rounded text-white p-2 text-center hover:bg-gray-500 hover:text-dolphin-gray cursor-pointer`
export const MSDS = tw.a`font-display bg-dolphin-gray flex text-white border items-center  text-sm lg:text-base border-2 border-dolphin-gray rounded text-white p-2 text-center hover:bg-gray-500 hover:text-dolphin-gray cursor-pointer`
export const WarrantyDownload = tw.a`font-display bg-dolphin-gray flex  text-white items-center  border text-sm lg:text-base  border-2 border-dolphin-gray rounded text-white p-2  text-center hover:bg-gray-500 hover:text-dolphin-gray cursor-pointer`
export const Brochure = tw.a`font-display bg-dolphin-gray  flex text-white border items-center  border-2  text-sm lg:text-base  border-dolphin-gray rounded text-white p-2 text-center hover:bg-gray-500 hover:text-dolphin-gray cursor-pointer`
export const Parts = tw.a`font-display bg-dolphin-gray  flex text-white items-center  border border-2 border-dolphin-gray text-sm lg:text-base    rounded text-white p-2 text-center hover:bg-gray-500 hover:text-dolphin-gray`
export const SafetyInstructions = tw.a`font-display bg-dolphin-gray  flex text-white border border-2 border-dolphin-gray text-sm lg:text-base rounded text-white p-2 text-center hover:bg-gray-500 hover:text-dolphin-gray cursor-pointer`
export const SpecInnerItem = tw.span`pl-4 flex flex-row items-center `
export const CircleSvg = styled(Circle)`
	${tw`mr-2`}
`

export const FeatureName = styled(AccordionButton)`
	${tw`relative pl-6 pt-4 pb-2 cursor-pointer overflow-hidden font-display uppercase font-semibold relative text-left`}

	> svg {
		${tw`absolute left-0 cursor-pointer`}
		transition: all 0.3s linear;
		color: #707b85;
		top: 16px;

		@media (max-width: 767px) {
			top: 13px;
		}
	}

	> svg.right {
		transform: rotate(0);
	}

	> svg.down {
		transform: rotate(90deg);
	}

	> button {
		${tw`hidden md:inline ml-2 relative`}
		top: 3px;
	}
`
export const CustomizedToolTip = styled(Tooltip)`
	${tw`font-display bg-blue-500 text-white rounded py-2 px-4 border-0`}
`

export const FeatureDescription = styled(AccordionPanel)`
	${tw`font-display text-gray-700 mb-4`}
`
export const AnimatedDescription = animated(FeatureDescription)

export const ReadMore = styled(Link)`
	${tw`ml-2`}
`

export const ReadMoreBtn = tw.button`underline hover:no-underline`

export const ItemSummaryContainer = tw.section`flex w-full flex-col lg:flex-row`
export const ItemDetailsContainer = styled.div`
	${tw`flex flex-col bg-gray-300 w-full lg:w-3/6 p-8 md:p-8 xl:p-16 mx-auto`}

	p:first-of-type {
		${tw`mb-2`}
	}

	a {
		${tw`font-sans`}
	}

	> ul {
		${tw`w-full`}

		> li {
			${tw`list-disc ml-4`}
		}
	}
`
export const ItemTitle = tw.h2`font-display text-2xl md:text-3xl w-full mb-6`
export const ItemDetails = tw.p`font-display leading-relaxed text-gray-700`
export const ItemImage = styled.img`
	${tw`mr-auto mt-6`}
	max-height: auto;
	max-width: 100%;
`
export const VideoContainer = styled.div`
	${tw`w-full lg:w-3/6 flex flex-col items-center justify-center bg-gray-500`}

	> iframe {
		min-height: 400px;
		max-height: auto;
	}

	@media (min-width: 1024px) and (max-width: 1279px) {
		> iframe {
			min-height: 300px;
			max-height: 400px;
		}
	}

	@media (max-width: 767px) {
		> iframe {
			min-height: 250px;
			max-height: 350px;
		}
	}
`
export const ThumbnailsContainer = tw.div`flex flex-row p-2 md:p-6 bg-gray-500 flex-wrap w-full`
export const ThumbContainer = styled.div`
	@media (min-width: 525px) {
		${tw`w-4/12`}
	}
	${tw`relative px-4 w-6/12 my-2`}
`
export const Thumbs = styled.img`
	src: url(${props => props.src});
`
export const SvgContainer = styled.div`
	${tw`absolute h-full flex top-0 items-center justify-center cursor-pointer`}
	width: calc(100% - 2rem);
`
export const StyledSvg = styled(PlayCircle)`
	${tw`m-auto cursor-pointer rounded-full`}
	background-color: rgba(0,0,0,.5);
`

export const SummaryCtaContainer = styled.div`
	${tw`flex mt-8 flex-row w-full h-full md:items-end`}
`
export const SummaryButton = styled.a`
	${tw`font-sans ml-2 border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-transparent hover:text-dolphin-gray text-dolphin-gray py-3 px-6 rounded cursor-pointer`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const Book = styled(Link)`
	${tw`font-sans ml-2 border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-transparent hover:text-dolphin-gray text-dolphin-gray py-3 px-6 rounded cursor-pointer`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const Novideo = tw.p`text-lg font-display font-bold text-white py-8 lg:py-0`

export const DolphinBanner = styled.section`
	height: 100%;
	min-height: 800px;
	${tw`w-full bg-cover bg-no-repeat bg-center`}
	background-color: #c5cbc0;
	background-image: url(${({ sources }) => (sources ? sources[0].base64 : '')});

	@media (min-width: 1280px) and (max-width: 1399px) {
		min-height: 700px;
	}
	@media (min-width: 1024px) and (max-width: 1279px) {
		min-height: 600px;
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		min-height: 500px;
	}
	@media (max-width: 767px) {
		min-height: 350px;
	}
`
export const DolphinBannerContainer = styled.div`
	@media(min-width: 525px) {
		${tw`px-12`}
	}
	${tw`flex flex-col lg:flex-row w-full h-full relative bg-cover bg-no-repeat px-4 pt-6 lg:px-16 lg:pt-12 items-center`}
	min-height: 800px;

	background-image: url(${({ sources }) => (sources ? sources[0].srcWebp : '')});
	background-image: url(${({ sources }) => (sources ? sources[0].src : '')});

	@media (min-width: 1400px) and (max-width: 1699px) {
		${tw`bg-bottom py-8`}
		background-image: url(${({ sources }) => (sources ? sources[1].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 1280px) and (max-width: 1399px) {
		background-image: url(${({ sources }) => (sources ? sources[2].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
		min-height: 700px;
	}
	@media (min-width: 1024px) and (max-width: 1279px) {

		> svg {
			width: 200px;
		}

		background-image: url(${({ sources }) => (sources ? sources[3].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[3].src : '')});
		min-height: 600px;
	}

	@media (min-width: 1024px) {
		${tw`lg:items-start`}
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		background-image: url(${({ sources }) => (sources ? sources[4].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[4].src : '')});
		min-height: 500px;

		> svg {
			width: 180px;
		}
	}
	@media (min-width: 525px) and (max-width: 767px) {
		background-image: url(${({ sources }) => (sources ? sources[5].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[5].src : '')});
		min-height: 350px;

		> svg {
			width: 180px;
		}
	}
	@media (max-width: 524px) {
		background-image: url(${({ sources }) => (sources ? sources[6].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[6].src : '')});
		min-height: 350px;

		> svg {
			width: 150px;
		}
	}
`
export const BannerTextHolder = tw.div`flex flex-col static lg:absolute right-0 lg:pt-4 xl:pt-0 lg:w-6/12 xl:w-auto`
export const FullSectionCol = tw.section`flex flex-col w-full`
export const DolphinSeries = styled.p`
	@media (min-width: 525px) {
		${tw`text-3xl w-9/12`}
	}
	${tw`font-display font-bold relative text-2xl md:text-4xl xl:text-5xl text-white mt-8 mb-4 flex flex-row items-center w-11/12  lg:justify-end justify-center xl:justify-start mx-auto lg:pl-0 xl:pl-6`}
	> span {
		${tw`uppercase`}
		text-shadow: 4px 4px 8px #000;
	}
	svg {
		${tw`ml-4 xl:ml-8 w-2/6 rounded-lg border-none lg:static xl:absolute right-0 h-full`}
	}
`
export const BannerText = tw.p`font-display text-white text-xl md:text-2xl xl:text-3xl w-9/12 m-auto text-center lg:text-right`

export const SeriesItemsContainer = styled.div`
	${tw`flex flex-row flex-wrap w-full mt-8 md:-mt-24 xl:-mt-32 xxl:-mt-40`}

	z-index: 0;
`
export const NoItems = tw.p`py-8 text-3xl font-display uppercase w-full text-center`
export const ItemContainer = styled.div`
	@media (min-width: 525px) {
		${tw`w-6/12`}
	}
	${tw`flex flex-col items-center justify-end w-full md:w-4/12 lg:w-3/12 xl:w-1/5 pb-8 md:pb-12`}
`
export const SeriesItemImage = styled.picture`
	${tw`mb-4`}
	max-height: 200px;
	/* src: url(${props => props.src}); */

	@media (max-width: 1279px) {
		max-height: 180px;
	}
	@media (max-width: 767px) {
		max-height: 150px;
	}

	> img {
		@media (max-width: 1279px) {
			max-height: 180px;
		}
		@media (max-width: 767px) {
			max-height: 150px;
		}
		max-height: 200px;
	}
`
export const ItemLink = styled(Link)`
	${tw`flex flex-row items-center justify-center`}

	svg {
		transform: rotate(90deg);
	}
`
export const ItemTtl = tw.p`font-display text-blue-500 md:text-2xl lg:text-3xl xxl:text-4xl mr-3`
export const CompareModels = styled.a`
	${tw`w-full bg-yellow-500 text-center py-4 font-display text-white uppercase tracking-widest hover:bg-yellow-400 cursor-pointer`}
`
export const SpecificationsTitle = tw.h2`font-display text-white text-3xl bg-yellow-500 text-center py-1`
export const SpecsContainer = tw.div`flex flex-wrap font-display mt-12 md:mt-16 mb-8 mx-auto flex-col md:flex-row w-11/12 md:w-9/12`
export const SpecificationsItem = styled.div`
	${tw`flex flex-row w-full md:w-3/6`}

	&:nth-of-type(4n+1),
	&:nth-of-type(4n+2) {
		${tw`bg-gray-300`}
	}
	p {
		${tw`text-center w-3/6 p-2 border-white border-solid border-2`}

		&:first-of-type {
			${tw`font-bold`}
		}
	}

	svg {
		display: initial;
	}
`
export const ProductIframe = styled.iframe`
	${tw`my-auto`}
	height: 400px;
	width: 530px;
`
export const Stock = styled.p`
	${tw`font-display text-lg`}

	> .nostock {
		${tw`text-red-500`}
	}

	> .linkto {
		${tw`px-2 py-1 rounded-md bg-blue-500 hover:bg-blue-400 text-white cursor-pointer`}
	}
`
export const HyperLinkText = tw.a`font-display underline italic text-blue-600 hover:no-underline cursor-pointer`
export const Bold = tw.b`font-bold`
export const Italic = tw.i`italic`
export const UnderlinedText = tw.u`underline`
